export const modalhandler = status => {
  return {
    type: "ShowModal",
    payload: status
  };
};
export const closemodal = () => {
  return { type: "ShowModal", payload: "none" };
};



// WEBPACK FOOTER //
// ./src/actions/modal-handler.js